import React from "react";
import {FaXmark} from "react-icons/fa6";

const DetailSection = ({icon: Icon, title, onRemove, children, removeBtn = true, className = ""}) => (
    <section className={`rounded-lg border border-slate-200 bg-white p-4 shadow-sm ${className}`}>
        <div className="mb-3 flex items-center justify-between gap-3">
            <h4 className="flex items-center gap-2 text-sm font-semibold text-slate-700"><Icon className="text-slate-400" />{title}</h4>
            {removeBtn && (
                <button type="button" onClick={onRemove} className="rounded p-1 text-slate-400 hover:bg-red-50 hover:text-red-600" title={`Excluir ${title.toLowerCase()}`} aria-label={`Excluir ${title.toLowerCase()}`}>
                    <FaXmark />
                </button>
            )}
        </div>
        {children}
    </section>
);

export default DetailSection;
